import $ from 'jquery'
import textMixins from './textMixins'
import {StateChanges} from '../store/stateChanges'
import {Text} from '../texts'

export default {
  name: 'routeGlobals',
  mixins: [textMixins],
  data () {
    return {
      helpRootDir: '/static',
      helpPagesSubDir: '/help/Content/Tiberias/'
    }
  },
  methods: {
    initExperimentWindow () {
      $('#classes_for_analysis_popup').modal('show')
    },
    initExperimentClasses () {
      if (this.allClasses.length === 0) {
        this.$store.commit(StateChanges.ADD_CLASS, new Text())
        this.$store.commit(StateChanges.ADD_CLASS, new Text())
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/routeGlobals.js